module.exports = __webpack_public_path__ + "img/box-arrow-down.8aa779ce.svg";